export class ClearStateForm {
    static readonly type = "[Form Templates] Clear state form template";

    constructor() {}
}
